module.exports = "/assets/data/3b034548de3e6a30ec63eebe303abfc4-EC1N.data.json";